import { KulionerReceiptSectionProps } from "../types";
import { colors, margin } from "../constants";

export const renderFooter = ({
  doc,
  pageWidth,
  pageHeight,
  data
}: KulionerReceiptSectionProps): void => {
  let finalY = doc.lastAutoTable.finalY;
  const remainingVSpace = pageHeight - margin.top - margin.bottom - finalY;

  if (remainingVSpace > 4.5) {
    finalY = doc.lastAutoTable.finalY + 5;
  } else {
    finalY = margin.top;
    doc.addPage();
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.setTextColor(colors.primary);

  const totalText = "Total kuantitas";
  const totalValue = String(data.koProduct.reduce((acc, curr) => acc + curr.kodQuantity , 0));
  const textWidth = doc.getTextWidth(totalText);
  const valueWidth = doc.getTextWidth(totalValue);

  doc.text(totalText, pageWidth - margin.right - textWidth, finalY);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(colors.accent);
  doc.text(totalValue, pageWidth - margin.right - valueWidth, (finalY += 4));
};
